<template>
    <form class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '輸入提示'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md" v-html="content.html"></div>
                    <div class="md">
                        <ul class="func">
                            <li v-if="value === content.min">
                                <cpBtn
                                    title="sub"
                                    icon="remove"
                                    :disabled="true"
                                ></cpBtn> 
                            </li>
                            <li v-else>
                                <cpBtn
                                    title="sub"
                                    icon="remove"
                                    @click.stop="sub"
                                ></cpBtn>  
                            </li>
                            <li>
                                <div class="cp input range no-tag">
                                    <input type="range" v-model="value" :min="content.min" :max="content.max" :step="content.step">
                                </div>
                            </li>
                            <li v-if="value < content.max">
                                <cpBtn
                                    title="add"
                                    icon="add"
                                    @click.stop="add"
                                ></cpBtn>    
                            </li>
                            <li v-else>
                                <cpBtn
                                    title="add"
                                    icon="add"
                                    :disabled="true"
                                ></cpBtn>    
                            </li>
                            <li class="is-status">{{ content.unit? value +' '+ content.unit: value }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'
    import cpBtn from '@/components/cpBtn'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
            cpBtn,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            return {
                value: 0,
                styleSet: $styleSet
            }
        },
        computed: {
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                $results.push($action);
                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            sendFuncEvent: function(func){ //多 btn 功能

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            _value = this.value;

                        $content[func](_value);
                    }
                });
            },
            sub: function(){
                let $content = this.content,
                    _min = parseFloat($content.min, 10),
                    _step = parseFloat($content.step, 10);

                let _value = parseFloat(this.value, 10);

                if( _value - _step >= _min ) {
                    this.$set(this, 'value', _value - _step);
                }
            },
            add: function(){
                let $content = this.content,
                    _max = parseFloat($content.max, 10),
                    _step = parseFloat($content.step, 10);

                let _value = parseFloat(this.value, 10);

                if( _value + _step <= _max ) {
                    this.$set(this, 'value', _value + _step);
                }
            },
            action: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            $_action = $content.action,
                            _value = this.value;

                        if( $content.actionStopClose !== true ) {
                            this.close();
                        }

                        $_action(_value);
                    }
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            setValue: function(){
                let $content = this.content,
                    _value = $content.value;

                if( _value ) {
                    this.$set(this, 'value', _value);
                }
            },
        },
        created: function(){
            this.setValue();
        }
    }
</script>

<style scoped lang="scss">

    .md {

        > ul {
            list-style: none;
            margin: 0;
            padding: 0;
            padding-top: 10px;

            > li {
                display: inline-block;
                vertical-align: middle;

                &.is-status {
                    padding: 0 10px;
                    text-align: center;
                }
            }
        }
    }
</style>
